<template>
  <section
    id="about"
    class="hide-overflow"
  >
    <v-layout white>
      <v-flex
        xs12
        md6
        pa-5
      >
        <base-bubble-1
          style="transform: translate(5%, -5%)"
        />
        <base-heading class="info--text">
          About Me
        </base-heading>

        <base-text class="mb-5">
          Activities based in Kanagawa Ebina city.
        </base-text>

        <base-subheading class="info--text">
          Skills
        </base-subheading>
        <base-text class="mb-5">
          Access AMP Angular AngularJS Apache ASP.NET Core C# Cordova CreateJS CSS Electron Firebase Git HTML Ionic Java JavaScript MySQL Nginx Nuxt.js Oracle PHP Python Ruby React SQL Server TypeScript Vue.js MuleSoft
        </base-text>

        <v-alert
          outlined
          color="info"
        >
          <v-layout
            v-for="(skill, i) in skills"
            :key="i"
            style="color: #69A1BB;"
            wrap
          >
            <v-flex
              xs6
              text-uppercase
              v-text="skill.name"
            />
            <v-flex
              xs6
              text-xs-right
              v-text="`${skill.value}%`"
            />
            <v-progress-linear
              :value="skill.value"
              color="info"
              height="8"
            />
          </v-layout>
        </v-alert>
      </v-flex>
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="require('@/assets/outdoor-pc.jpg')"
          height="100%"
        />
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {
  data: () => ({
    skills: [
      {
        name: 'Web Development',
        value: 90
      },
      {
        name: 'Other',
        value: 10
      }
    ]
  })
}
</script>
